export type CreateDataProps = {
  sessionId: string;
  bookingId: string;
  paymentTotal: number;
  paymentCurrency: string;
  paymentProvider: PaymentProvider;
  email?: string;
};

export type GetCancelDataProps = {
  sessionId: string;
  clientId: string;
  paymentProvider: PaymentProvider;
};
export type GetDataProps = {
  sessionId: string;
  clientId: string;
  paymentProvider: PaymentProvider;
};

export type UpdateDataProps = CreateDataProps & GetCancelDataProps;

export type CreateDataQueryResult = {
  paymentOrderCreation: PaymentIntent;
};

export type GetDataQueryResult = {
  paymentOrderSelection: PaymentIntent;
};

export type UpdateDataQueryResult = {
  paymentOrderUpdation: PaymentIntent;
};

export type CancelDataQueryResult = {
  paymentOrderCancellation: PaymentIntent;
};

export type PaymentIntent = {
  id: string;
  client_secret: string;
  status: string;
  token?: string;
  message?: string;
  paymentProvider: PaymentProvider;
};

export type PaymentType = 'card';

export type PaymentProvider = 'revolut' | 'stripe';

export type Currencies = 'HUF' | 'EUR' | 'USD';

export const Currencies = {
  EUR: '€',
  HUF: 'Ft',
  USD: '$',
};

export type CurrencyType = keyof typeof Currencies;

export type TotalPayment = {
  serviceFee: number;
  totalPayment: number;
};
